<template>
	<div id="searchDriver">
		<section class="content-header">
			<div class="container-fluid">
				<div class="row mb-2">
					<div class="col-md-6 col-12">
						<h1>{{ $t("label.report")}}</h1>
					</div>
					<div class="col-md-6">
						<ol class="breadcrumb float-sm-right">
							<li class="breadcrumb-item"><router-link to="/">{{ $t("label.home")}}</router-link></li>
							<li class="breadcrumb-item active">{{ $t("label.report")}}</li>
						</ol>
					</div>
				</div>
			</div>
		</section>

		<div class="content">
			<div class="container-fluid">
                <div class="row">
					<div class="col-md-12">
						<div class="card card-primary card-outline">
							<div class="card-header">
								<h3 class="card-title">{{ $t("label.filter")}}</h3>
<!--                                <div class="card-tools">-->
<!--                                    <button type="button" class="btn btn-tool" data-widget="collapse" search @click="collapse.display = !collapse.display">-->
<!--                                        <fa :icon="collapse.display ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>-->
<!--                                    </button>-->
<!--                                </div>-->
							</div>
							<div class="card-body">
                                <div class="form-group row">
                                    <label class="col-md-4">{{ $t('label.office_code') }}</label>
                                    <div class="col-md-8">
                                        <v-select
                                            v-model="search.office_code"
                                            :options="offices"
                                            index="code"
                                            v-validate="'required'"
                                            label="full_name"
                                            name="office_code">
                                        </v-select>
                                        <span v-if="errors.has('office_code')" class="text-danger">
                                            {{ errors.first('office_code') }}
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4">{{ $t('label.from_date') }}</label>
                                    <div class="col-md-8">
                                        <datepicker 
                                            v-model="search.from_date"
                                            v-validate="'required'"
                                            name="from_date"
                                            :bootstrap-styling="true"
                                            :highlighted="highlightedCurrentDate"
                                            :language="lang"
                                            :format="'dd/MM/yyyy'"
                                            :clear-button="true"
                                            :disabledDates="{ from: new Date(Date.now()) }"
                                            @selected="changeToDate"
                                            input-class="form-control form-control-datepicker can-editable"
                                            :inline="false">
                                        </datepicker>
                                        <span v-if="errors.has('from_date')" class="text-danger">
                                            {{ errors.first('from_date') }}
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row mb-0">
                                    <label class="col-md-4">{{ $t('label.to_date') }}</label>
                                    <div class="col-md-8">
                                        <datepicker
                                            v-model="search.to_date"
                                            v-validate="'required'"
                                            name="to_date"
                                            :bootstrap-styling="true"
                                            :highlighted="highlightedCurrentDate"
                                            :language="lang"
                                            :format="'dd/MM/yyyy'"
                                            :clear-button="true"
                                            :disabledDates="{ from: new Date(Date.now()), to: new Date(search.from_date) }"
                                            input-class="form-control form-control-datepicker can-editable"
                                            :inline="false">
                                        </datepicker>
                                        <span v-if="errors.has('to_date')" class="text-danger">
                                            {{ errors.first('to_date') }}
                                        </span>
                                    </div>
                                </div>
							</div>
                            <div class="card-footer">
                                <button v-if="$hasPermission('tempvehicle.application.view')" type="button" class="btn btn-sm btn-primary float-right" @click.prevent="searchReport">
                                    <fa :icon="fas.faEye"/> 
                                    {{ $t('label.view') }}
                                </button>
                            </div>
						</div>
					</div>
				</div>

                <div class="row" v-if="reportDatas.length > 0">
					<div class="col-md-12">
						<div class="card card-success card-outline">
							<div class="card-header">
								<h3 class="card-title">{{ $t("label.result")}}</h3>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-widget="collapse" :title="$t('label.collapse')" @click="collapse.display = !collapse.display">
                                        <fa :icon="collapse.display ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
                                    </button>
                                </div>
							</div>
							<div class="card-body">
                                <div class="table-responsive" v-if="reportDatas.length > 0">
                                    <table class="table table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th nowrap rowspan="2" style="vertical-align: middle; text-align: center;">{{ $t('label.n0') }}</th>
                                                <th nowrap colspan="5">{{ $t('label.lodgement') }}</th>
                                                <th nowrap colspan="5">{{ $t('label.vehicle') }}</th>
                                                <th nowrap colspan="3">{{ $t('label.destination') }}</th>
                                                <th nowrap rowspan="2" style="vertical-align: middle; text-align: center;">{{ $t('label.status') }}</th>
                                            </tr>
                                            <tr class="cursor-pointer">
                                                <th nowrap>{{ $t('label.type') }}</th>
                                                <th nowrap>{{ $t('label.number') }}</th>
                                                <th nowrap>{{ $t('label.date') }}</th>
                                                <th nowrap>{{ $t('label.code') }}</th>
                                                <th nowrap>{{ $t('label.name') }}</th>
                                                <th nowrap>{{ $t('label.brand') }}</th>
                                                <th nowrap>{{ $t('label.plate_number') }}</th>
                                                <th nowrap>{{ $t('label.steer') }}</th>
                                                <th nowrap>{{ $t('label.color') }}</th>
                                                <th nowrap>{{ $t('label.frame_number') }}</th>
                                                <th nowrap>{{ $t('label.date') }}</th>
                                                <th nowrap>{{ $t('label.code') }}</th>
                                                <th nowrap>{{ $t('label.name') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="reportDatas.length > 5">
                                                <tr v-for="index in 5" :key="index">
                                                    <td nowrap>{{ index }}</td>
                                                    <td nowrap>{{ reportDatas[index].registration_type }}</td>
                                                    <td nowrap>{{ reportDatas[index].registration_number }}</td>
                                                    <td nowrap>{{ reportDatas[index].lodgement_office_date }}</td>
                                                    <td nowrap>{{ reportDatas[index].lodgement_office_code }}</td>
                                                    <td nowrap>{{ reportDatas[index].lodgement_office_name }}</td>
                                                    <td nowrap>{{ reportDatas[index].vehicle_brand }}</td>
                                                    <td nowrap>{{ reportDatas[index].vehicle_plate_number }}</td>
                                                    <td nowrap>{{ reportDatas[index].vehicle_steer }}</td>
                                                    <td nowrap>{{ reportDatas[index].vehicle_color }}</td>
                                                    <td nowrap>{{ reportDatas[index].vehicle_frame_number }}</td>
                                                    <td nowrap>{{ reportDatas[index].destination_office_date }}</td>
                                                    <td nowrap>{{ reportDatas[index].destination_office_code }}</td>
                                                    <td nowrap>{{ reportDatas[index].destination_office_name }}</td>
                                                </tr>
                                                <tr>
                                                    <td nowrap> ... </td>
                                                    <td nowrap> ... </td>
                                                    <td nowrap> ... </td>
                                                    <td nowrap> ... </td>
                                                    <td nowrap> ... </td>
                                                    <td nowrap> ... </td>
                                                    <td nowrap> ... </td>
                                                    <td nowrap> ... </td>
                                                    <td nowrap> ... </td>
                                                    <td nowrap> ... </td>
                                                    <td nowrap> ... </td>
                                                    <td nowrap> ... </td>
                                                    <td nowrap> ... </td>
                                                    <td nowrap> ... </td>
                                                </tr>
                                                <tr>
                                                    <td nowrap>{{ reportDatas.length }}</td>
                                                    <td nowrap>{{ reportDatas[reportDatas.length-1].registration_type }}</td>
                                                    <td nowrap>{{ reportDatas[reportDatas.length-1].registration_number }}</td>
                                                    <td nowrap>{{ reportDatas[reportDatas.length-1].lodgement_office_date }}</td>
                                                    <td nowrap>{{ reportDatas[reportDatas.length-1].lodgement_office_code }}</td>
                                                    <td nowrap>{{ reportDatas[reportDatas.length-1].lodgement_office_name }}</td>
                                                    <td nowrap>{{ reportDatas[reportDatas.length-1].vehicle_brand }}</td>
                                                    <td nowrap>{{ reportDatas[reportDatas.length-1].vehicle_plate_number }}</td>
                                                    <td nowrap>{{ reportDatas[reportDatas.length-1].vehicle_steer }}</td>
                                                    <td nowrap>{{ reportDatas[reportDatas.length-1].vehicle_color }}</td>
                                                    <td nowrap>{{ reportDatas[reportDatas.length-1].vehicle_frame_number }}</td>
                                                    <td nowrap>{{ reportDatas[reportDatas.length-1].destination_office_date }}</td>
                                                    <td nowrap>{{ reportDatas[reportDatas.length-1].destination_office_code }}</td>
                                                    <td nowrap>{{ reportDatas[reportDatas.length-1].destination_office_name }}</td>
                                                </tr>
                                            </template>
                                            <template v-else>
                                                <tr v-for="(reportData, index) in reportDatas" :key="index">
                                                    <td nowrap>{{(pageNumber*10-10)+index+1}}</td>
                                                    <td nowrap>{{ reportData.registration_type }}</td>
                                                    <td nowrap>{{ reportData.registration_number }}</td>
                                                    <td nowrap>{{ reportData.lodgement_office_date }}</td>
                                                    <td nowrap>{{ reportData.lodgement_office_code }}</td>
                                                    <td nowrap>{{ reportData.lodgement_office_name }}</td>
                                                    <td nowrap>{{ reportData.vehicle_brand }}</td>
                                                    <td nowrap>{{ reportData.vehicle_plate_number }}</td>
                                                    <td nowrap>{{ reportData.vehicle_steer }}</td>
                                                    <td nowrap>{{ reportData.vehicle_color }}</td>
                                                    <td nowrap>{{ reportData.vehicle_frame_number }}</td>
                                                    <td nowrap>{{ reportData.destination_office_date }}</td>
                                                    <td nowrap>{{ reportData.destination_office_code }}</td>
                                                    <td nowrap>{{ reportData.destination_office_name }}</td>
                                                    <td nowrap>{{ reportData.status }}</td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>                                    
                                </div>
                                <div v-if="reportDatas.length <= 0">
                                    {{ $t('label.no_data') }}
                                </div>
							</div>
                            <div class="card-footer" v-if="reportDatas.length > 0">
                                <xlsx-workbook :filename="'Temporary Vehicle Report.xlsx'">
                                    <xlsx-sheet
                                        v-for="sheet in sheets"
                                        :key="sheet.name"
                                        :collection="sheet.data"
                                        :sheet-name="sheet.name"
                                    >
                                    </xlsx-sheet>
                                    <xlsx-download 
                                        :filename="filename">
                                        <button v-if="$hasPermission('tempvehicle.application.view')" type="button" class="btn btn-primary float-right" style="margin-right: 5px;">
                                            <fa :icon="fas.faDownload"/>
                                            {{ $t('label.download') }}
                                        </button>
                                    </xlsx-download>
                                </xlsx-workbook>
                            </div>
						</div>
                    </div>
                </div>
			</div>
		</div>
	</div>  
</template>

<script>
    import { fas } from "@fortawesome/free-solid-svg-icons";
    import { mapState } from "vuex";
    // https://vue-xlsx.netlify.com/
    import { XlsxRead, XlsxTable, XlsxSheets, XlsxJson, XlsxWorkbook, XlsxSheet, XlsxDownload } from "vue-xlsx/dist/vue-xlsx.es.js"
    export default {
        name: "Report",
        components: {
            XlsxRead,
            XlsxTable,
            XlsxSheets,
            XlsxJson,
            XlsxWorkbook,
            XlsxSheet,
            XlsxDownload
        },
        computed: {
            fas() {
                return fas;
            },
            ...mapState("user", ["user"]),
            office(){
                if(this.user){
                    if(this.user.data.office) {
                        let allOffice = [];
                        this.user.data.office.forEach(function(office) {
                            if(typeof office == 'object'){
                                allOffice.push(office.code);
                            }else{
                                allOffice.push(office);
                            }
                        });
                        return allOffice;
                    }
                    return this.user.data.office;
                }
                return [];
            },
            offices(){
              let user_offices = this.office;
              let border_offices = this.$store.getters['reference/offices'];
              return border_offices.filter(item => user_offices.includes(item.code));
            },
        },
        data() {
            return {
                baseURI: "",
                sheets: [],
                search: {
                    from_date: '',
                    to_date: '',
                    office_code: ''
                },
                reportDatas: [],
                filename: '',
                pageNumber:1,
                collapse:{
                    search: false,
                    display: false,
                }
            }
        },
        mounted() {
            this.changeCSS();
        },
        updated() {
            this.changeCSS();
        },
        methods: {
            changeToDate(dateChange) {
                this.search.to_date = '';
            },
            changeCSS() {
                $("body .readonly").removeAttr("style");
                $("body .can-editable").css("background-color", "white");
            },
            searchReport(e) {
                this.$validator.validate()
                    .then(result => {
                        if (!result) {
                            this.sheets = [];
                            this.reportDatas = [];
                            e.preventDefault();
                        }else{
                            this.$store.state.loading.status = true;                        
                            let url = this.baseURI+'/report';
                            GDCE_Client.requestApi("POST", url, this.search).then(response => {
                                if(response.status) {
                                    if(response.data.length > 0) {
                                        this.reportDatas = response.data;
                                        this.filename = response.filename;
                                        this.sheets.push({ 
                                            name: response.name, 
                                            data: response.data
                                        });
                                    } else {
                                        this.sheets = [];
                                        this.reportDatas = [];
                                        this.$swal({
                                          title: this.$t('message.no_result'),
                                          icon: "info",
                                          text: this.$t('label.no_data'),
                                          buttons:{
                                          },
                                          timer: 2500
                                        });
                                    }
                                    this.$store.state.loading.status = false;
                                }
                            }).catch(error => {
                                this.$store.state.loading.status = false;
                            });
                        }
                    }
                );
            },
        }
        
    }
</script>

<style scoped>
    div.options > label > input {
        visibility: hidden;
    }

    div.options > label {
        display: block;
        margin: 0 0 0 -10px;
        padding: 0 0 20px 0;  
        height: 20px;
        cursor: pointer;
    }

    div.options > label > img {
        display: inline-block;
        padding: 0px;
        height:30px;
        width:30px;
        background: none;
    }

    div.options > label > input:checked +img {  
        background: url('../../assets/images/onebit_34.png');
        background-repeat: no-repeat;
        background-position:center center;
        background-size:30px 30px;
    }
</style>